import { EvidenceServiceApiKey } from "@app/injectionKeys";
import { injectStrict } from "@app/utils/injectStrict";
import { readonly, Ref, ref } from "vue";

const isEnabled = ref<boolean | null>(null);
let statusPromise: Promise<void> | null = null;

export function useMiraIntegration() {
  const evidenceService = injectStrict(EvidenceServiceApiKey);

  async function load(force = false) {
    if (force) {
      statusPromise = null;
    }

    if (!statusPromise) {
      statusPromise = evidenceService.api
        .settingsControllerGetMiraIntegrationStatus()
        .then(({ data }) => {
          isEnabled.value = data.isEnabled;
        })
        .catch(() => {
          isEnabled.value = false;
        });
    }

    await statusPromise;
  }

  function setEnabled(value: boolean) {
    isEnabled.value = value;
  }

  return {
    isEnabled: readonly(isEnabled) as Ref<boolean>,
    load,
    setEnabled,
  };
}
